var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalNoOfStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Total_no._of_station",
    "data-name": "Total no. of station",
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.79,
    height: 92.79,
    viewBox: "0 0 92.79 92.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.79,
    height: 92.79,
    rx: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 89.79,
    height: 89.79,
    rx: 9.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun-bikecycle-4359616",
    transform: "translate(14.433 13.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M32.725,7.112a1.065,1.065,0,0,0-1.43.477l-2.13,4.261a1.065,1.065,0,0,0,.949,1.541h1.472l-1.36,2.719a1.065,1.065,0,1,0,1.906.952l2.13-4.261a1.065,1.065,0,0,0-.952-1.541H31.837L33.2,8.541A1.065,1.065,0,0,0,32.725,7.112Z",
    transform: "translate(-0.226 -1.674)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M53.131,38.978A12.676,12.676,0,0,0,46.92,40.6a7.755,7.755,0,0,1-.181-1.647V35.322L50.4,33.948a2.539,2.539,0,0,0,1.652-2.427h.01V26.2a3.2,3.2,0,0,0-3.2-3.2H39.816a2.663,2.663,0,0,0,0,5.326h6.924V29.85L42.8,31.33a2.142,2.142,0,0,0-1.385,2v2.457H26.093l-1.065-2.13h2.99a2.743,2.743,0,0,0,.274-5.472l-3.968-.4a3.2,3.2,0,0,0-3.682-2.611,3.285,3.285,0,0,0-2.663,3.267v2.016a3.2,3.2,0,0,0,3.2,3.2h1.472l1.549,3.1-2.876,4.025a12.783,12.783,0,1,0,6.192,12.05h2.336a4.251,4.251,0,0,0,3.044,3.044v3.347a1.065,1.065,0,0,0,1.065,1.065h3.2v-2.13h-2.13V55.87a4.218,4.218,0,0,0,2.187-6.83L41.7,42.755a10.038,10.038,0,0,0,.728,2.033,12.777,12.777,0,1,0,10.706-5.811ZM20.109,30.456V28.44a1.154,1.154,0,0,1,.879-1.163,1.111,1.111,0,0,1,.186-.016,1.065,1.065,0,0,1,1.044,1.278,1.065,1.065,0,0,0,.937,1.278l4.924.492a.611.611,0,0,1-.062,1.212H21.174A1.065,1.065,0,0,1,20.109,30.456ZM46.14,49.2l3.221,3.027a2.643,2.643,0,0,0,1.823.723h.1a2.65,2.65,0,0,0,1.867-.863,2.738,2.738,0,0,0-.19-3.784L49.7,45.138a7.386,7.386,0,0,1,3.431-.834,7.508,7.508,0,1,1-6.991,4.9ZM39.283,25.663a.533.533,0,0,1,.533-.533h3.728V26.2H39.816A.533.533,0,0,1,39.283,25.663Zm6.391.533V25.13h3.2A1.065,1.065,0,0,1,49.935,26.2v2.86a2.7,2.7,0,0,0-1.065.033V27.261A1.065,1.065,0,0,0,47.8,26.2Zm-2.13,7.129L49.3,31.169a.55.55,0,0,1,.42.016.353.353,0,0,1,.194.2.435.435,0,0,1-.25.569L45.3,33.586a1.065,1.065,0,0,0-.69,1v4.367A10.029,10.029,0,0,0,47.636,46.1l3.843,3.735h0a.614.614,0,0,1,.107.814.533.533,0,0,1-.763.032l-4.805-4.516a7.883,7.883,0,0,1-2.474-5.717Zm-2.13,6.164L35.481,47.8a4.179,4.179,0,0,0-1.128-.254l4.913-6.878a1.065,1.065,0,0,0-.866-1.688H29.088a1.065,1.065,0,0,0-.922,1.6l4.162,7.209c.007.012.018.021.026.033a4.24,4.24,0,0,0-.99.586,1.065,1.065,0,0,0-.122-.372l-4.168-7.219a1.065,1.065,0,0,0-.871-.533,1.052,1.052,0,0,0-.918.445l-5.157,7.219a1.065,1.065,0,0,0,.866,1.685h9.3a4.186,4.186,0,0,0-.441,1.065h-13l9.131-12.782H41.413Zm-8.069,5.8-2.412-4.178h5.4ZM28.473,47.5H23.062l2.993-4.188ZM13.835,52.249a1.065,1.065,0,0,0,.948.577h7.371A7.456,7.456,0,1,1,18.2,45.139l-4.286,6A1.065,1.065,0,0,0,13.835,52.249Zm.948,10.164A10.652,10.652,0,1,1,20.075,42.52l-.633.886a9.573,9.573,0,1,0,4.865,9.42h1.074a10.666,10.666,0,0,1-10.6,9.587Zm20.239-8.818V51.761h-2.13v1.834a2.13,2.13,0,1,1,2.13,0Zm18.109,8.818A10.652,10.652,0,0,1,43.707,46.8a9.671,9.671,0,0,0,.783.852,9.557,9.557,0,1,0,3.741-4.122,7.926,7.926,0,0,1-.567-.908,10.652,10.652,0,1,1,5.467,19.792Z",
    transform: "translate(-1.991 -0.631)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M48.621,54.154a4.261,4.261,0,0,0,5.142-6.221,1.065,1.065,0,1,0-1.811,1.12A2.13,2.13,0,0,1,50.135,52.3a2.094,2.094,0,0,1-.754-.137,1.065,1.065,0,0,0-.76,1.991Z",
    transform: "translate(1.005 0.96)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M13.032,48.486a1.066,1.066,0,0,0-1.232-1.74,4.261,4.261,0,0,0,3.906,7.488,1.065,1.065,0,1,0-.721-2,2.16,2.16,0,0,1-.723.125,2.13,2.13,0,0,1-1.229-3.87Z",
    transform: "translate(-1.469 0.905)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M32.848,2a10.663,10.663,0,0,0-10.476,8.778L20.656,9.635a1.065,1.065,0,0,0-1.182,1.773l3.2,2.13a1.024,1.024,0,0,0,.115.054.986.986,0,0,0,.107.05.948.948,0,0,0,.737,0,.987.987,0,0,0,.107-.05,1.025,1.025,0,0,0,.115-.054l3.2-2.13a1.065,1.065,0,0,0-1.182-1.773l-1.244.83A8.515,8.515,0,0,1,39.9,7.869a1.065,1.065,0,1,0,1.762-1.2A10.652,10.652,0,0,0,32.848,2Z",
    transform: "translate(-0.882 -2)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M24.955,15.917a1.065,1.065,0,1,0-1.908.948A10.652,10.652,0,0,0,43.2,13.025l1.585,1.057a1.065,1.065,0,0,0,1.182-1.773l-3.2-2.13a1.056,1.056,0,0,0-.713-.162.155.155,0,0,0-.054,0,.625.625,0,0,1-.075.023.959.959,0,0,0-.118.038,1.028,1.028,0,0,0-.372.2l-3.046,2.031a1.065,1.065,0,1,0,1.182,1.773l1.481-.987a8.522,8.522,0,0,1-16.1,2.823Z",
    transform: "translate(-0.625 -1.478)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNoOfStation);
export default __webpack_public_path__ + "static/media/TotalNoOfStation.fca1cf1bef7be9d6b4a4e8a3ba1a0b80.svg";
export { ForwardRef as ReactComponent };